<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Veículo",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader   },
  setup() {

  },
  data() {
    return {
      title: "Editar Veículo",
      items: [
        {
          text: "Veículos",
          href: "/veiculos/list",
        },
        {
          text: "Editar Veículo",
          active: true,
        },
      ],
      veiculoData: {
        id: 0,
        status: 'A'
      },
      idData: 0,
      activeTab: 0,
      submitted: false,
      updating: true,
      errosValid: null,
    };
  },

  methods: {

    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/veiculo`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.veiculoData = res.data[0]
        this.idData = this.veiculoData.id
        this.title = `Editar Veículo (${this.veiculoData.id}) ${this.veiculoData.descricao}`
        this.updating = false
      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      if (this.veiculoData.placa) {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/veiculo`, {
          veiculoData: this.veiculoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0) {
            this.idData = res.data[0].id
            this.veiculoData = res.data[0]
            this.$router.replace('/veiculo/editar/' + this.idData)
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },

  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Novo Veículo`
      this.updating = false
    }
  },

}


</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="veiculoData.status"/>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

            </div>
          </div>
        </div>
      </div>

      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações Principais</h4>
                <form class="needs-validation" @submit.prevent="formSubmit">

                  <div class="row mb-3">


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="placa">Placa</label>
                        <input
                            id="placa"
                            v-model="veiculoData.placa"
                            type="text"
                            class="form-control"
                            placeholder="Placa"
                            :class="{'is-invalid': submitted && !veiculoData.placa}"/>
                        <div v-if="submitted && !veiculoData.placa"
                             class="invalid-feedback">
                          <span>Campo placa obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="tipo">Tipo Veículo</label>
                        <select
                            id="tipo"
                            v-model="veiculoData.tipo"
                            class="form-control">
                          <option value="CA">Carro</option>
                          <option value="MT">Moto</option>
                          <option value="CN">Caminhão</option>
                          <option value="CA">Carreta</option>
                          <option value="UT">Utilitário</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="estado">Estado</label>
                        <select id="estado" v-model="veiculoData.estado" class="form-control">
                          <option value="AC">Acre</option>
                          <option value="AL">Alagoas</option>
                          <option value="AP">Amapá</option>
                          <option value="AM">Amazonas</option>
                          <option value="BA">Bahia</option>
                          <option value="CE">Ceará</option>
                          <option value="ES">Espírito Santo</option>
                          <option value="GO">Goiás</option>
                          <option value="MA">Maranhão</option>
                          <option value="MT">Mato Grosso</option>
                          <option value="MS">Mato Grosso do Sul</option>
                          <option value="MG">Minas Gerais</option>
                          <option value="PA">Pará</option>
                          <option value="PB">Paraíba</option>
                          <option value="PR">Paraná</option>
                          <option value="PE">Pernambuco</option>
                          <option value="PI">Piauí</option>
                          <option value="RJ">Rio de Janeiro</option>
                          <option value="RN">Rio Grande do Norte</option>
                          <option value="RS">Rio Grande do Sul</option>
                          <option value="RO">Rondônia</option>
                          <option value="RR">Roraima</option>
                          <option value="SC">Santa Catarina</option>
                          <option value="SP">São Paulo</option>
                          <option value="SE">Sergipe</option>
                          <option value="TO">Tocantins</option>
                          <option value="DF">Distrito Federal</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="renavam">Renavam</label>
                      <div class="position-relative">
                        <input
                            id="renavam"
                            type="text"
                            v-model="veiculoData.renavam"
                            class="form-control"
                            placeholder="Renavam"/>
                      </div>
                    </div>
                  </div>


                  <div class=" row mb-3">

                    <div class="col-md-2">
                      <label for="chassi">Chassi</label>
                      <div class="position-relative">
                        <input
                            id="chassi"
                            type="text"
                            v-model="veiculoData.chassi"
                            class="form-control"
                            placeholder="Chassi"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="anofab">Ano Fabricação</label>
                      <div class="position-relative">
                        <input
                            id="anofab"
                            type="number"
                            v-model="veiculoData.anofab"
                            class="form-control"
                            placeholder="Ano Fabricação"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="anomodelo">Ano Modelo</label>
                      <div class="position-relative">
                        <input
                            id="anomodelo"
                            type="number"
                            v-model="veiculoData.anomodelo"
                            class="form-control"
                            placeholder="Ano Modelo"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="marca">Marca</label>
                      <div class="position-relative">
                        <input
                            id="marca"
                            type="text"
                            v-model="veiculoData.marca"
                            class="form-control"
                            placeholder="Marca"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="modelo">Modelo</label>
                      <div class="position-relative">
                        <input
                            id="modelo"
                            type="text"
                            v-model="veiculoData.modelo"
                            class="form-control"
                            placeholder="Modelo"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="cor">Cor</label>
                      <div class="position-relative">
                        <input
                            id="cor"
                            type="text"
                            v-model="veiculoData.cor"
                            class="form-control"
                            placeholder="Cor"/>
                      </div>
                    </div>

                  </div>


                  <div class=" row mb-3">

                    <div class="col-md-2">
                      <label for="motor">Motor</label>
                      <div class="position-relative">
                        <input
                            id="motor"
                            type="text"
                            v-model="veiculoData.motor"
                            class="form-control"
                            placeholder="Motor"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="transm">Tipo Transmissão</label>
                        <select
                            id="transm"
                            v-model="veiculoData.transm"
                            class="form-control">
                          <option value="MN">Manual</option>
                          <option value="AT">Automática</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="proprietario">Proprietário</label>
                      <div class="position-relative">
                        <input
                            id="proprietario"
                            type="text"
                            v-model="veiculoData.proprietario"
                            class="form-control"
                            placeholder="Proprietário"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="tipofrota">Tipo Frota</label>
                        <select id="tipofrota"
                                v-model="veiculoData.tipofrota"
                                class="form-control">
                          <option value="AG">Agregada</option>
                          <option value="FP">Frota Própria</option>
                          <option value="TZ">terceirizada</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="tipocarroc">Tipo Carroceria</label>
                        <select id="tipocarroc"
                                v-model="veiculoData.tipocarroc"
                                class="form-control">
                          <option value="BU">Baú</option>
                          <option value="PC">Prancha</option>
                          <option value="SD">Sider</option>
                          <option value="RG">Refrigerado</option>
                          <option value="TQ">Tanque</option>
                        </select>
                      </div>
                    </div>

                  </div>


                  <div class=" row mb-3">

                    <div class="col-md-2">
                      <label for="capackg">Capacidade KG</label>
                      <div class="position-relative">
                        <input
                            id="capackg"
                            type="number"
                            v-model="veiculoData.capackg"
                            class="form-control"
                            placeholder="Capacidade KG"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="capacmcubic">Capacidade M³</label>
                      <div class="position-relative">
                        <input
                            id="capacmcubic"
                            type="number"
                            v-model="veiculoData.capacmcubic"
                            class="form-control"
                            placeholder="Capacidade M³"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="baucomp">Comprimento Baú</label>
                      <div class="position-relative">
                        <input
                            id="baucomp"
                            type="number"
                            v-model="veiculoData.baucomp"
                            class="form-control"
                            placeholder="Comprimento Baú"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="baularg">Largura Baú</label>
                      <div class="position-relative">
                        <input
                            id="baularg"
                            type="number"
                            v-model="veiculoData.baularg"
                            class="form-control"
                            placeholder="Largura Baú"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="bauaut">Altura Baú</label>
                      <div class="position-relative">
                        <input
                            id="bauaut"
                            type="number"
                            v-model="veiculoData.bauaut"
                            class="form-control"
                            placeholder="Altura Baú"/>
                      </div>
                    </div>

                  </div>

                  <div class=" row mb-3">

                    <div class="col-sm-2">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <h5 class="font-size-14">Status</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            v-model="veiculoData.status">
                          {{ veiculoData.status === 'A' ? 'Ativo' : 'Inativo' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                  </div>

                  <div class=" row mb-3">
                    <div class="mb-12">
                      <label for="obs">Observações</label>
                      <textarea
                          id="obs"
                          v-model="veiculoData.obs"
                          type="text"
                          rows="3"
                          class="form-control"
                          placeholder="Observações"/>
                    </div>
                  </div>

                </form>

              </div>
            </div>
          </b-card-text>

        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-photo-album d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Fotos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Fotos do Veículo</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              :disabled="true"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Nova Foto
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">URL</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Nível</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link">
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-sitemap d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Documentos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Documentos relacionados ao veículo</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              :disabled="true"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Novo Documento
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Nível</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-bot d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Custos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Abastecimento, serviços, peças, etc... </h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              :disabled="true"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Novo Registro
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Quantidade</th>
                          <th scope="col">Valor</th>
                          <th scope="col">Status</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link">
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>

            </div>
          </b-card-text>
        </b-tab>

      </b-tabs>
    </div>

  </Layout>
</template>
